/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_01_TitleInputs */

const en_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neon Cyber`)
};

const ar_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نيون سايبر`)
};

const bn_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিয়ন সাইবার`)
};

const de_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neon-Cyber`)
};

const es_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciber neón`)
};

const fr_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cyber néon`)
};

const pt_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciber néon`)
};

const zh_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`霓虹网络`)
};

const tr_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neon Siber`)
};

const ru_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неоновый Кибер`)
};

const pl_elastic_gallery_item_01_title = /** @type {(inputs: Elastic_Gallery_Item_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neonowy Cyber`)
};

/**
* | output |
* | --- |
* | "Neon Cyber" |
*
* @param {Elastic_Gallery_Item_01_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_01_title = /** @type {((inputs?: Elastic_Gallery_Item_01_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_01_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_01_title(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_01_title(inputs)
	if (locale === "de") return de_elastic_gallery_item_01_title(inputs)
	if (locale === "es") return es_elastic_gallery_item_01_title(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_01_title(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_01_title(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_01_title(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_01_title(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_01_title(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_01_title(inputs)
	return en_elastic_gallery_item_01_title(inputs)
});